import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {PipelineViewFragment as PipelineViewFragmentType} from './__generated/PipelineViewFragment';

// PERFORMANCE: Lineage nodes intentionally request only `step { id }` and
// `outputStepData { id }` instead of the full PipelineStepFragment /
// PipelineStepDataFragment spreads. The complete step objects are already
// fetched in PipelineFragment's top-level `steps` array — duplicating them
// here would cause the backend to re-resolve every step field (status, config,
// edges, raw data, etc.) for each lineage node, resulting in hundreds of
// redundant connector/DB calls on large analyses. Consumers should use the
// resolver utilities (resolveLineageStep, resolveOutputStepData) to look up
// full step objects by ID from the `steps` array.
export const PIPELINE_VIEW_FRAGMENT = gql`
  fragment PipelineViewFragment on PipelineViewNode {
    lineage {
      step {
        id
      }
      stepOutputReference {
        outputStepData {
          id
        }
        rawDataIndex
      }
    }
  }
`;

export const PipelineViewFragment: FragmentWrapper<PipelineViewFragmentType> = {
  fragment: PIPELINE_VIEW_FRAGMENT,
  fragmentName: 'PipelineViewFragment',
};
